import { FC } from 'react';
import { ICategory } from '../../../model/ICategory';
import Switch from '../form/Switch';
import { ICategoryIdsItem } from '../../../model/IImportForm';

// export interface INestedItem {
//   id: string | number,
//   title: string,
//   children: INestedItem[];
// }

const NestedList: FC<{
  items?: ICategory[],
  selectedIds?: ICategoryIdsItem[],
  onToggle?: (id: ICategoryIdsItem) => unknown,
}> = ({
  items,
  selectedIds = [],
  onToggle = () => {},
}) => !items?.length 
  ? null
  : (
    <>
      {items.map(({ id, name, children_data, position }) => (
        <ul
          key={`nestedList${id}`}
          className=" flex flex-col py-1"
        >
          <li>
            <div className="flex gap-2 items-center px-4">
              <Switch
                label={name}
                isNoLabelArea
                size="small"
                name='group'
                value={selectedIds.includes(`${id}-${position}`)}
                isTrunicate
                handleToggle={() => onToggle(`${id}-${position}`)}
              />
            </div>
            
            {!!children_data?.length && (
              <div className="pt-2 border-t-[1px] mt-2 px-4">
                <NestedList
                  items={children_data}
                  selectedIds={selectedIds}
                  onToggle={onToggle}
                />
              </div>
            )}
          </li>
        </ul>
      ))}
    </>
  );

export default NestedList;
